import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  IconChevronBottom,
  IconChevronTop,
  SpacerHorizontal,
  TouchableFrame,
  Typography,
  View,
} from '@klarna/bubble-ui';

const componentPropTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  icon: PropTypes.node,
  titleLarge: PropTypes.bool,
};

type ComponentProps = PropTypes.InferProps<typeof componentPropTypes>;

const ExpandableFrame: React.FC<ComponentProps> = ({
  title = '',
  children,
  icon = null,
  titleLarge = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <TouchableFrame onPress={() => setIsExpanded(!isExpanded)} cornerRadiusToken="corner-radius/s">
      <View style={{ display: 'flex', flexDirection: 'column' }}>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {icon && (
            <View style={{ alignItems: 'left', flexDirection: 'column', paddingRight: '15px' }}>
              {icon}
            </View>
          )}
          <View style={{ alignItems: 'left', flexDirection: 'column', flexGrow: 1 }}>
            <Typography
              textToken={
                titleLarge
                  ? 'text-style/headings/titles/bold/tertiary'
                  : 'text-style/text/labels/tall/medium'
              }
            >
              {title}
            </Typography>
          </View>
          <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <SpacerHorizontal spaceToken="space/200" />
            {isExpanded ? <IconChevronTop /> : <IconChevronBottom />}
          </View>
        </View>
        {isExpanded && (
          <View
            style={{ paddingLeft: icon ? '35px' : '10px', alignItems: 'left', textAlign: 'left' }}
          >
            <SpacerHorizontal spaceToken="space/200" />
            {children}
          </View>
        )}
      </View>
    </TouchableFrame>
  );
};

ExpandableFrame.displayName = 'ExpandableFrame';
ExpandableFrame.propTypes = componentPropTypes;

export default ExpandableFrame;
